// extracted by mini-css-extract-plugin
module.exports = {"productCard":"_2Du2R _1-WGA","loadingWrapper":"Z-3es"};